module.exports = __webpack_public_path__ + "img/quizmayhem_banner_movie_generic.6409767d.jpg";